<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/uxema@2x.webp 2x, {CDN_URL}/ventures/uxema.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/uxema@2x.jpg 2x, {CDN_URL}/ventures/uxema.jpg 1x', type: 'image/jpg' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/75775133/Uxema-Brand-Identity-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")
        .u-mb-xs
        AppLink(to="https://www.behance.net/gallery/78146969/Uxema-UXUI-Design" :title="$t('cta2')" class="button-link  " v-html="$t('cta2')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Uxema",
    "pageDesc":"Uxema is an online platform for UXers through which they can collaborate on projects and share their knowledge.",
    "mantra":"Uxema UX |platform.",
    "content":"<p>The UX field is huge. With many processes and methodologies, the process of auditing or providing UX to clients could overlap and become confusing. And when it comes to large domain projects, the process of documentation and writing takes up lots of time. In addition, finding the right template for every project case could be overwhelming as well. And to make uxers work easier, enhance their performance and make ux work more fun, we came up with Uxema.</p><p>Uxema is a platform that provides ready to use UX tools, templates and documents, that UXers can use and extract in different formats like proposals. Through a drag and drop feature, UXers can easily select the methods of research and analyze the needed to documents based on the project scope. The platform walks them through a sequential process from business analysis to user research and wireframing.</p><p>The platform will be launched by late 2019 but you check the brand and website design on Behance.</p>",
    "cta":"Brand identity",
    "cta2":"UX/UI design"
  },
  "ar": {
    "pageTitle":"يوكسيما",
    "pageDesc":"يوكسيما هى منصة متخصصة من أجل مهندسي تجربة المستخدم حيث يمكنهم من خلالها التعاون فيما بينهم وتبادل المعارف والخبرات.",
    "mantra":"يوكسيما منصة |لتجربة المستخدم.",
    "content":"<p>مجال تجربة المستخدم واسع وضخم للغاية. مع وجود العديد من المنهجيات والعمليات يمكن أن تتداخل عملية التدقيق أو توفير تجربة مستخدم مميزة للعملاء وتتسبب في حدوث بعض الارتباكات والحيرة. وعندما يتعلق الأمر بمشروعات واسعة النطاق، تجد أن عملية التوثيق والكتابة تستغرق الكثير من الوقت. بالإضافة إلى ذلك يمكن أن تجد القالب الذي تبحث عنه والمناسب للمشروع الذي تعمل عليه مرهق للغاية. لهذا توصلنا إلى إنشاء يوكسيما من أجل تسهيل عمل مهندسي تجربة المستخدم وتحسين أدائهم وجعل تجربة المستخدم أكثر متعة. </p><p>يوكسيما هى منصة توفر الأدوات والقوالب والوثائق التي يحتاجها أي فرد من أجل إنشاء تجربة مستخدم سليمة واستخراج تنسيقات فريدة يمكن استخدامها كالمقترحات. من خلال ميزة السحب والإفلات يمكن لمهندسي تجربة المستخدم تحديد طرق البحث وتحليل المستندات المطلوبة تبعًا لنطاق المشروع بسهولة. ترشدهم المنصة من خلال عملية متسلسلة بدءًا من تحليل الأعمال إلى أبحاث المستخدم والاطارات الشبكية.</p><p>سوف يتم إطلاق المنصة بحلول أواخر عام 2019 لكن يمكنك التحقق من من تصميم العلامة التجارية وتصميم الموقع على بيهانس.</p>",
    "cta":"تصميم العلامة التجارية",
    "cta2":"تصميم تجربة المستخدم/ وواجهة المستخدم"
  }
}
</i18n>
